import { Stack, Typography } from "@mui/material";

function TotalScoreBadge({
  score,
  shouldDisplay,
}: {
  score: number | string | undefined;
  shouldDisplay: boolean;
}) {
  return (
    <Stack alignItems="center" spacing={0.75} sx={{ width: "30%" }}>
      <svg
        aria-label={`Earthly Rating ${score}`}
        role="img"
        viewBox="0 0 64 64"
        width="100%"
        style={{ display: "block", maxWidth: 400 }}
      >
        <path
          d="M22.5 2H41.5L56.8 13.7L62.7 32L56.8 50.3L41.5 62H22.5L7.2 50.3L1.3 32L7.2 13.7Z"
          fill="#000000"
        />
        {shouldDisplay && (
          <text
            x="32"
            y="34"
            dominantBaseline="middle"
            textAnchor="middle"
            fill="white"
            fontSize="24"
            fontWeight="900"
          >
            {score}
          </text>
        )}
      </svg>

      <Typography
        variant="body2"
        sx={{ whiteSpace: "nowrap", fontWeight: 900, fontSize: "1.25rem" }}
      >
        Earthly Rating
      </Typography>
    </Stack>
  );
}

export default TotalScoreBadge;
